module.exports = __webpack_public_path__ + "static/media/preref.d7fc307b.png";